import Head from 'next/head';
import PreviewBar from '../ui/PreviewBar';
import type { ReactNode } from 'react';

type SimpleLayoutProps = {
  children: ReactNode | ReactNode[];
  preview?: boolean;
  className?: string;
};

const SimpleLayout = ({
  preview,
  children,
}: SimpleLayoutProps): JSX.Element => {
  return (
    <>
      {preview && <PreviewBar />}
      {children}
    </>
  );
};

const LayoutHead = ({
  children,
}: Omit<SimpleLayoutProps, 'preview' | 'className'>): JSX.Element => (
  <>
    <Head>
      <meta name="viewport" content="width=device-width" />
      {children}
    </Head>
  </>
);

const Header = ({
  children,
  className,
}: Omit<SimpleLayoutProps, 'preview'>): JSX.Element => (
  <header className={className}>{children}</header>
);

const Main = ({
  children,
  className,
}: Omit<SimpleLayoutProps, 'preview'>): JSX.Element => (
  <main className={className}>{children}</main>
);

const Footer = ({
  children,
  className,
}: Omit<SimpleLayoutProps, 'preview'>): JSX.Element => (
  <footer className={className}>{children}</footer>
);

SimpleLayout.Head = LayoutHead;
SimpleLayout.Header = Header;
SimpleLayout.Main = Main;
SimpleLayout.Footer = Footer;

export default SimpleLayout;
